<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import dialog from 'libs/dialog'
import util from 'libs/util'
import events from 'dom-helpers/events';
export default {
  name: 'App',
  created() {
    events.on(window, 'resize', this._getResizeHandler, false);
    this.setClientInfo();
  },
  methods: {
    _getResizeHandler() {
      this.setClientInfo();
      this.$eventBus.$emit('resize');
    },
    setClientInfo(){
      let clientHeight = util.getViewHeight();
      let clientWidth = util.getViewWidth();
      this.$store.dispatch('setClientHeight', clientHeight);
      this.$store.dispatch('setClientWidth', clientWidth);
    }
  },
  beforeDestroy() {
    events.off(window, 'resize', this._getResizeHandler, false)
  }
}
</script>
<style>
#app {
  height: 100%;
  min-width: 1300px;
}
.el-cascader-panel {
  max-height: 300px;
}
</style>